// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"416a1db1","507":"fac9243f"}[chunkId] + ".chunk.css";
};